import { Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface StateBadgeProps {
    state:
        | 'bloqueado'
        | 'activo'
        | 'inactivo'
        | 'presentado'
        | 'borrador'
        | 'procesando'
        | 'error de procesamiento'
        | 'invalid-value';
    text?: string;
    hideIcon?: boolean;
}

const StateBadge = ({ state, text, hideIcon }: StateBadgeProps) => {
    let icon = null;
    let stateText = '';
    let bgColor = '';
    let textColor = '';

    switch (state) {
        case 'bloqueado':
            icon = <InfoIcon sx={{ color: '#FF9900' }} fontSize="small" />;
            stateText = text || 'Bloqueado';
            bgColor = '#FFFBEA';
            textColor = '#FF9900';
            break;
        case 'activo':
            icon = <CheckCircleIcon sx={{ color: '#4CAF50' }} fontSize="small" />;
            stateText = text || 'Activo';
            bgColor = '#F3FAF3';
            textColor = '#4CAF50';
            break;
        case 'inactivo':
            icon = <CancelIcon sx={{ color: '#F44336' }} fontSize="small" />;
            stateText = text || 'Inactivo';
            bgColor = '#FEF3F2';
            textColor = '#F44336';
            break;
        case 'presentado':
            stateText = text || 'Recibido';
            bgColor = '#FFFBEA';
            textColor = '#FF9900';
            break;
        case 'borrador':
            stateText = text || 'Borrador';
            bgColor = '#E0EBED';
            textColor = '#1E272E';
            break;
        case 'procesando':
            stateText = text || 'Procesando';
            bgColor = '#EEEEEE';
            textColor = '#8C8C8C';
            break;
        case 'error de procesamiento':
            stateText = 'Error';
            bgColor = '#FEF3F2';
            textColor = '#F44336';
            break;
        default:
        case 'invalid-value':
            stateText = text || '-';
            bgColor = '#FEF3F2';
            textColor = '#F44336';
            break;
    }
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: bgColor,
                padding: '4px 8px',
                borderRadius: '16px',
                fontWeight: 'bold',
                color: textColor
            }}
        >
            {!hideIcon && icon}
            <span style={{ marginLeft: hideIcon ? 0 : '4px' }}>{stateText}</span>
        </Box>
    );
};

export default StateBadge;
